import { Box, Stack, styled, Typography } from '@mui/material';
import { MediaQueryProps } from '../types';

export const FeaturesOverviewSection = styled(Box, {
  shouldForwardProp: (prop: string) => !['ismobile', 'islaptop', 'iswidescreen'].includes(prop),
})<MediaQueryProps>`
  padding: ${({ ismobile, islaptop, iswidescreen }) => {
    if (ismobile) return '40px';
    if (islaptop) return '40px 10%';
    if (iswidescreen) return '60px 15%';
    return '40px 10%';
  }};
`;

export const FeaturesHighlights = styled(Box, {
  shouldForwardProp: (prop: string) => !['ismobile', 'islaptop'].includes(prop),
})<MediaQueryProps>`
  display: flex;
  flex-direction: ${({ ismobile }) => (ismobile ? 'column' : 'row')};
  gap: ${({ islaptop }) => (islaptop ? '70px' : '10%')};
  justify-content: space-between;
  padding-top: 40px;
`;

export const FeaturesHighlightColumn = styled(Stack)`
  flex: 1;
`;

export const FeaturesHighlightImage = styled('img')`
  width: 100%;
  max-width: 350px;
  align-self: center;
  padding: 2rem;
`;

export const FeaturesHighlightTitle = styled(Typography)`
  font-weight: 700;
  text-transform: capitalize;
  text-align: center;
`;
